
import { Link } from 'react-router-dom';

export const EmptyCart = () => {
  const topSellers = [
    { name: 'New Nairobi', href: '/explore?lane=new-nairobi' },
    { name: 'Boom Bap 254', href: '/explore?lane=boom-bap-254' },
    { name: 'Gengetone', href: '/explore?lane=gengetone' },
    { name: 'Drill 254', href: '/explore?lane=drill-254' }
  ];

  return (
    <div className="text-center py-16">
      {/* Illustration */}
      <div className="mb-8">
        <img
          src="/images/external/empty-cart-music.png"
          alt="Empty cart illustration"
          className="w-80 h-60 mx-auto object-cover object-top rounded-lg"
        />
      </div>
      
      {/* Content */}
      <div className="max-w-md mx-auto">
        <h2 className="text-2xl font-bold text-gray-900 mb-4">
          Your cart is empty
        </h2>
        <p className="text-gray-600 mb-8">
          Discover new drops from Kenya's finest hip hop artists and start building your collection.
        </p>
        
        {/* Primary CTA */}
        <Link to="/explore">
          <button className="bg-emerald-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-emerald-700 transition-colors cursor-pointer whitespace-nowrap mb-6">
            Explore Music
          </button>
        </Link>
        
        {/* Top Sellers */}
        <div>
          <p className="text-sm text-gray-500 mb-3">Popular lanes:</p>
          <div className="flex flex-wrap justify-center gap-2">
            {topSellers.map((seller) => (
              <Link
                key={seller.name}
                to={seller.href}
                className="px-3 py-1 bg-gray-100 text-gray-700 rounded-full text-sm hover:bg-emerald-100 hover:text-emerald-700 transition-colors"
              >
                {seller.name}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
